import { create } from 'zustand'

const useAppStore = create(set => ({
  lastRoute: null,
  navExpanded: true,

  // Actions
  setLastRoute: lastRoute => set({ lastRoute }),
  setNavExpanded: () => set(state => ({ navExpanded: !state.navExpanded }))
}))

export default useAppStore
